import { Polygon, Polyline } from '@react-google-maps/api'
import { observer } from 'mobx-react'
import React from 'react'

import { colors } from '@flowwai-frontend/design-system'
import { LocationValue } from '@flowwai-frontend/shared/common-components'

interface Props {
   geoShape: LocationValue
}

const GoogleMapsLayers = (props: Props): React.ReactElement => {
   const { geoShape } = props

   const commonStyles = {
      strokeColor: colors['error-400'],
      strokeOpacity: 1,
      strokeWeight: 2,
      clickable: false,
      draggable: false,
      editable: false
   }

   switch (geoShape.type) {
      case 'POLYGON': {
         return (
            <Polygon
               paths={geoShape.value}
               options={{
                  fillColor: colors['error-200'],
                  fillOpacity: 0.4,
                  ...commonStyles
               }}
            />
         )
      }
      case 'LINE': {
         return <Polyline path={geoShape.value} options={commonStyles} />
      }
      default:
         return <></>
   }
}

export default observer(GoogleMapsLayers)
